module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Logo"
  }, [_c('span', {
    staticClass: "Logo-segment"
  }, [_vm._v("Benjamin Drummond")]), _vm._v(" "), _c('span', {
    staticClass: "Logo-plus"
  }, [_vm._v("+")]), _vm._v(" "), _c('span', {
    staticClass: "Logo-segment"
  }, [_vm._v("Sara Joy Steele")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c21c46a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Logo.vue
// module id = 783
// module chunks = 1474